var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArrowRightG(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_332_1188",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 0,
    width: 6,
    height: 12
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.05489 12L8.94269 12L8.94269 0L3.05489 -5.14728e-07L3.05489 12Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_332_1188)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.23554 1.158L7.35394 5.9274L3.34114 10.8546C3.22852 10.9806 3.16691 11.144 3.16834 11.313C3.16713 11.4932 3.23722 11.6666 3.36334 11.7954C3.42516 11.8595 3.49914 11.9105 3.58094 11.9457C3.66274 11.9808 3.75072 11.9993 3.83974 12C3.93047 11.9982 4.01994 11.9783 4.10295 11.9417C4.18597 11.905 4.26088 11.8522 4.32334 11.7864L8.76334 6.3768C8.8811 6.24822 8.94576 6.07981 8.94431 5.90547C8.94287 5.73112 8.87541 5.5638 8.75554 5.4372L4.19554 0.208799C4.1347 0.142842 4.06084 0.0902038 3.97865 0.0542007C3.89645 0.0181976 3.80768 -0.000390502 3.71794 -0.00039051C3.62821 -0.000390518 3.53944 0.0181975 3.45724 0.0542006C3.37504 0.0902038 3.30119 0.142842 3.24034 0.208799C3.12151 0.337829 3.05505 0.506527 3.05394 0.681939C3.05283 0.857351 3.11715 1.02688 3.23434 1.1574",
    fill: "#999999"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRightG);
export default __webpack_public_path__ + "static/media/icon-arrow-right-g.c0bb74419835261f215f7e5c624ab530.svg";
export { ForwardRef as ReactComponent };